<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" :data="data" noDataText="Nenhum item encontrado no período selecionado">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" vs-xs="12">
            <div class="flex-wrap-reverse items-center flex-1">
              <!-- Datas -->
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                <div
                  class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-64"
                >
                  <feather-icon icon="CalendarIcon" svgClasses="h-4 " />
                  <span class="mr-2">{{ dateFilterText }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>

                <vs-dropdown-menu>
                  <vs-dropdown-item @click="setDateFilter(0)">
                    <span>Hoje</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setDateFilter(1)">
                    <span>Ontem</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setDateFilter(2)">
                    <span>Últimos 7 dias</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setDateFilter(3)">
                    <span>Últimos 30 dias</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setDateFilter(4)">
                    <span>Últimos 90 dias</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setDateFilter(5)">
                    <span>Todos os Registros</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <!-- futuramente este será o botão de salvar
              <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewDataSidebar = true">
                  <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                  <span class="ml-2 text-base text-primary">Exportar data</span>
              </div>
              -->
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="2" vs-xs="12" class="p-0">
            <vs-input
                icon="icon-search"
                icon-pack="feather"
                class="w-full input-rounded-full no-icon-border mb-4"
                placeholder= "Pesquisar"
                v-model="searchTerm"
            />
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-xs="12">
            <div class="con-vs-pagination vs-pagination-primary" v-show="meta.pagination.total_pages > 1">
              <vs-pagination :total="meta.pagination.total_pages" v-model="page" :max="5"></vs-pagination>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">DATA</vs-th>
        <vs-th sort-key="name">USUÁRIO</vs-th>
        <vs-th sort-key="name">DOMÍNIO</vs-th>
        <vs-th sort-key="category">SITE ACESSADO</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="linha" :key="index" v-for="(linha, index) in data">
          <vs-td class="text-nowrap">
            <span>{{data[index].datetime | formatDateTime}}</span>
          </vs-td>
          <vs-td>
            <span>{{data[index].user}}</span>
          </vs-td>
          <vs-td>
            <span>{{data[index].domain}}</span>
          </vs-td>
          <vs-td>
            <span>
              <a target="_blank" :href="data[index].fullurl">{{data[index].fullurl}}</a>
            </span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
let searching;
export default {
  data() {
    return {
      data: [],
      meta: {
        pagination: {
          total_pages: 0
        }
      },
      page: 1,
      dateFilterId: 5,
      dateFilterText: "Todos os Registros",
      searchTerm: ''
    };
  },

  watch: {
    page: function() {
      this.load();
    },
    searchTerm: function() {
      clearTimeout(searching);

      searching = setTimeout(() => {
        this.load();
      }, 400)
    },
  },

  mounted() {
    this.load();
  },

  methods: {
    handleChangePage: function(page) {
      this.page = page;
      this.load();
    },
    load: function() {
      this.$api
        .get(
          "/api/v1/desktop/httptraffic/" +
            this.$localStorage.get("licencekey") +
            "?page=" +
            this.page +
            "&dateFilterId=" +
            this.dateFilterId +
            "&search=" +
            this.searchTerm
        )
        .then(response => {
          this.data = response.data.data;
          this.meta = response.data.meta || { pagination: { total_pages: 0 } };
        });
    },
    setDateFilter: function(filterId) {
      this.dateFilterId = filterId;
      this.load();

      switch (this.dateFilterId) {
        case 0:
          this.dateFilterText = "Hoje";
          break;
        case 1:
          this.dateFilterText = "Ontem";
          break;
        case 2:
          this.dateFilterText = "Últimos 7 dias";
          break;
        case 3:
          this.dateFilterText = "Últimos 30 dias";
          break;
        case 4:
          this.dateFilterText = "Últimos 90 dias";
          break;
        case 5:
          this.dateFilterText = "Todos os Registros";
          break;
      }
    }
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
